import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

import TipoImpresionConstant from 'constants/tiposImpresion'

const TipoImpresionFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Row>
      <Form.Label text='Tipo Impresion' md={2}  />
      <Col md={1} className='pt-2'>
        <Field name='tipoImpresion'>
          {({ field }) => (
            <Form.Radio
              {...field}
              disabled={fIsSubmitting}
              checked={iValue === TipoImpresionConstant.TICKET}
              id={`radio-TICKET`}
              label={TipoImpresionConstant.__dictionary[TipoImpresionConstant.TICKET].nombre}
              value={TipoImpresionConstant.__dictionary[TipoImpresionConstant.TICKET].id}
            />
          )}
        </Field>
      </Col>
      <Col md={1} className='pt-2'>
        <Field name='tipoImpresion'>
          {({ field }) => (
            <Form.Radio
              {...field}
              disabled={fIsSubmitting}
              checked={iValue === TipoImpresionConstant.A4}
              id={`radio-A4`}
              label={TipoImpresionConstant.__dictionary[TipoImpresionConstant.A4].nombre}
              value={TipoImpresionConstant.__dictionary[TipoImpresionConstant.A4].id}
            />
          )}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(TipoImpresionFormGroup)
